import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {SpecialtyMedicalGuideModel} from 'domain/usecases';
import {UseHealthSpecialtiesGuideQueryParams} from './types';
import {getHealthSpecialties} from '../../services/getHealthSpecialties';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum, HealthGuideServicesTypeEnum} from 'presentation/constants';

export function useHealthSpecialtiesGuideQuery({
	enabled,
	...params
}: UseHealthSpecialtiesGuideQueryParams) {
	const {isEnabled: isSpecialtyDisabledEmergencyFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_DISABLE_SPECIALTY_INPUT_FOR_EMERGENCY,
	);
	const {isEnabled: isSpecialtyDisabledElectiveFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_DISABLE_SPECIALTY_INPUT_FOR_ELECTIVE_HOSPITAL,
	);
	const {isEnabled: isSemanticSearchEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_SEMANTIC_SEARCH_MEDICAL_GUIDE,
	);

	const serviceType = params.nmServico;

	const isServiceTypeDisabled =
		serviceType === HealthGuideServicesTypeEnum.MATERNITY ||
		(isSpecialtyDisabledEmergencyFlagEnabled &&
			serviceType === HealthGuideServicesTypeEnum.EMERGENCY) ||
		(isSpecialtyDisabledElectiveFlagEnabled &&
			serviceType === HealthGuideServicesTypeEnum.ELECTIVE_HOSPITAL) ||
		(isSemanticSearchEnabled && serviceType === HealthGuideServicesTypeEnum.AUXILIARY_SERVICES);

	const shouldFetchSpecialties = Boolean(
		params.cdPlanoANS &&
		params.cdUf &&
		params.nmCidade &&
		params.nmServico &&
		!isServiceTypeDisabled,
	);

	return useQuery<SpecialtyMedicalGuideModel[]>({
		queryKey: [QUERY_KEYS.HEALTH_SPECIALTIES_GUIDE, params],
		queryFn: ({signal}) => getHealthSpecialties({...params, signal}),
		enabled: shouldFetchSpecialties && enabled !== false,
	});
}
